import * as Yup from 'yup';
import { fields } from '@synergy/utils';

import { EmployeeFormikValues } from './models/employee-formik-values';

const fieldNames = fields<EmployeeFormikValues>();

export const userManagementValidationSchema = Yup.object().shape({
    [fieldNames.formOfAddress]: Yup.string().required('app.error.required'),
    [fieldNames.positionId]: Yup.number().typeError('app.error.required').required('app.error.required'),
    [fieldNames.lastName]: Yup.string().required('app.error.required'),
    [fieldNames.firstName]: Yup.string().required('app.error.required'),
    [fieldNames.phone]: Yup.string().required('app.error.required'),
    [fieldNames.email]: Yup.string().email('app.error.email').required('app.error.required'),
});
